module.exports = __webpack_public_path__ + "img/goods13_3.3c67f219.jpg";